document.addEventListener('click',async function(event){
  const button=event.target.closest('[data-jb-ritual]');
  if(!button||button.disabled)return;
  const status=button.parentElement.querySelector('.jb-ritual-status');
  button.disabled=true;status.textContent='Adding your ritual…';
  try{
    const root=window.Shopify?.routes?.root||'/';
    const items=button.dataset.items.split(',').filter(Boolean).map(id=>({id:Number(id),quantity:1,properties:{Ritual:button.dataset.name}}));
    const response=await fetch(root+'cart/add.js',{method:'POST',headers:{'Content-Type':'application/json',Accept:'application/json'},body:JSON.stringify({items})});
    const result=await response.json();
    if(!response.ok)throw new Error(typeof result.description==='string'?result.description:'We couldn’t add the whole ritual. Please check availability and try again.');
    window.location.assign(root+'cart');
  }catch(error){status.textContent=error.message;button.disabled=false;}
});
